/**
 * 商务平板路由
 * */
export default [
  {
    path: "/laptopIndex",
    name: "laptopIndex",
    meta: {
      title: '首页'
    },
    component: () => import("@/views/laptopSystem/index")
  },
  {
    path: '/laptopSystemChannelList',
    name: 'laptopSystemChannelList',
    component: () => import('@/views/laptopSystem/deviceManage/channelList'),
    meta: {
      title: '渠道管理'
    }
  },{
    path: '/laptopSystemMachineList',
    name: 'laptopSystemMachineList',
    component: () => import('@/views/laptopSystem/deviceManage/machineList'),
    meta: {
      title: '机型管理'
    }
  },{
    path: '/laptopSystemDeviceList',
    name: 'laptopSystemDeviceList',
    component: () => import('@/views/laptopSystem/deviceManage/deviceList'),
    meta: {
      title: '设备管理'
    }
  },{
    path: '/laptopSystemAddModelPage',
    name: 'laptopSystemAddModelPage',
    meta: {
      title: '新增机型'
    },
    component: () => import('@/views/laptopSystem/deviceManage/addModelPage')
  },{
    path: '/laptopSystemEditModelPage',
    name: 'laptopSystemEditModelPage',
    meta: {
      title: '编辑机型'
    },
    component: () => import('@/views/laptopSystem/deviceManage/editModelPage')
  },{
    path: '/laptopSystemCheckModel',
    name: 'laptopSystemCheckModel',
    component: () => import('@/views/laptopSystem/deviceManage/checkModel'),
    meta: {
      title: '查看机型'
    }
  },
  {
    path: '/laptopVirtualSnBatchList',
    name: 'laptopVirtualSnBatchList',
    component: () => import("@/views/laptopSystem/deviceManage/virtualSnBatchList"),
    meta: {
      title: '授权批次'
    }
  }, {
    path: '/laptopVirtualSnLicenseList',
    name: 'laptopVirtualSnLicenseList',
    component: () => import("@/views/laptopSystem/deviceManage/virtualSnLicenseList"),
    meta: {
      title: '授权许可'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/laptopRouter.js